import type { JSX } from 'react';
import { Alert } from '@ksyos/design-system';
import type { LumbarRadiculopathyReferralData } from '@common/validation/customControls/neurology/lumbarRadiculopathy/lumbarRadiculopathyReferral/lumbarRadiculopathyReferral';
import { useEditFormSectionInputFieldContext } from '@frontend/formEngine/editForm/useEditFormContext';
import { useProcessActivityEditContext } from '@frontend/utils';

export function ToestemmingPatient(): JSX.Element {
    const { data, errors } = useProcessActivityEditContext<LumbarRadiculopathyReferralData>();
    const { onChange } = useEditFormSectionInputFieldContext();

    const key = 'toestemming_patient_voor_benaderen_feedback';
    const hasError = errors.has(key);
    const isChecked = Boolean(data[key]);

    return (
        <Alert
            appearance={hasError ? 'warning' : 'info'}
            className={hasError ? 'has-danger' : ''}
        >
            We vragen toestemming om de patiënt kort te benaderen voor feedback over hun zorgervaring
            <Alert.Checkbox
                checked={isChecked}
                label={
                    <Alert.Text
                        as="span"
                        size="sm"
                    >
                        Patiënt geeft toestemming om benaderd te worden voor feedback
                    </Alert.Text>
                }
                onChange={(event) => onChange(event.target.checked)}
                sx={{ mt: 4 }}
            />
        </Alert>
    );
}
